// File attachment handler
// Handles click events for file attachment links to open in new tabs

document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation to handle both existing and dynamically added file attachment links
  document.addEventListener('click', function(e) {
    const attachmentLink = e.target.closest('.attachment-preview-link');
    if (attachmentLink) {
      e.preventDefault();
      const url = attachmentLink.href;
      if (url) {
        // Open in new tab - most reliable approach for external storage URLs
        window.open(url, '_blank');
      }
    }
  });
});
